import React, { lazy, Suspense } from 'react';

import type { SharingZoomController } from '../SharingZoomController';

const UseZoomPan = lazy(() => import('./UseZoomPan'));
const UseKeyboard = lazy(() => import('./UseKeyboard'));

interface Props {
    target: HTMLVideoElement;
    controllerRef: React.RefObject<SharingZoomController | null>;
}

/**
 * Lazy-обёртка над UseZoomPan.
 * Загружает @use-gesture/react отдельным чанком.
 */
export const SuspendedUseZoomPan: React.FC<Props> = (props) => (
    <Suspense fallback={null}>
        <UseZoomPan {...props} />
        <UseKeyboard controllerRef={props.controllerRef} />
    </Suspense>
);
